import {
  Sheet,
  SheetContent,
  SheetTitle,
  SheetTrigger,
} from '@design-system/Sheet';
import { Info } from 'lucide-react';
import type { PriceInfo } from './ShopPageViews';
import { TickMarkIcon } from '@/components/icons/TickMarkIcon';
import EventTracker from '@/utils/EventTracker';
import { analyticsEvent } from '@utils/analyticsEvent';

export const PriceDiscountSheet = ({ priceInfo }: { priceInfo: PriceInfo }) => {
  const savings =
    Number(priceInfo.monthlyPriceWithOutDiscount) -
    Number(priceInfo.displayMonthlyPrice);
  const hasDuration = Number(priceInfo.offerDuration?.split(' ')[0]) > 0;
  const items = [
    ...(savings > 0
      ? [
          {
            text: `Save $${savings.toFixed(2)}/month${hasDuration ? ` for ${priceInfo.offerDuration}` : ''}`,
            highlighted: true,
          },
        ]
      : []),
    { text: '30-day supply, paid & delivered monthly', highlighted: false },
    { text: 'Pause or cancel anytime', highlighted: false },
    ...(savings > 0 && hasDuration
      ? [
          {
            text: `Pay $${priceInfo.displayMonthlyPrice}/month during the first ${priceInfo.offerDuration}; $${priceInfo.monthlyPriceWithOutDiscount}/month after ${priceInfo.offerDuration}`,
            highlighted: false,
          },
        ]
      : []),
  ];

  return (
    <Sheet>
      <SheetTrigger
        aria-label="Pricing details"
        className="inline-flex shrink-0 items-center justify-center rounded-sm p-1 text-tertiary focus-visible:outline focus-visible:outline-2"
        onClick={() =>
          EventTracker.trackEvent(
            'shop',
            analyticsEvent.SHOP_MYFORMULAS_PRICE_TAG_INFO,
          )
        }
      >
        <Info size={18} aria-hidden="true" />
      </SheetTrigger>
      <SheetContent
        modal
        className="w-full max-md:h-auto md:w-[400px]"
        aria-describedby={undefined}
      >
        <SheetTitle className="sr-only">Pricing details</SheetTitle>
        <ul className="flex flex-col gap-4 p-6 pt-12 pb-8 md:my-auto">
          {items.map(({ text, highlighted }) => (
            <li key={text} className="flex items-start gap-3">
              <TickMarkIcon className="mt-1 shrink-0" />
              <p
                className={
                  highlighted
                    ? 'typography-title text-background-success'
                    : 'typography-body'
                }
              >
                {text}
              </p>
            </li>
          ))}
        </ul>
      </SheetContent>
    </Sheet>
  );
};
